import { isDefined } from "./functions";

export const startsWithIgnoreCase = (
  itemValue: string,
  current: string,
): boolean => {
  return itemValue.toLocaleLowerCase().startsWith(current.toLocaleLowerCase());
};

export const capitalizeFirstLetter = (
  str: string | undefined | null,
): string => {
  if (!isDefined(str) || str.length === 0) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
